// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

/**
 * @fileoverview Zod schema for the branches VCA collection.
 *
 * Git branches from any connected provider.
 *
 * Identity tuple: (gitConnectionId, repoId, name)
 * ID prefix: brn_
 */

import { z } from 'zod'

export const branchesSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),

  // ── Git connection reference ──────────────────────────────────────────
  gitConnectionId: z.string().max(100),
  codebaseId: z.string().max(100).optional(),

  // ── Identity tuple ────────────────────────────────────────────────────
  repoId: z.string().max(200),
  /** Branch name (e.g. 'main', 'feature/my-feature'). */
  name: z.string().max(500),

  // ── Branch state ─────────────────────────────────────────────────────
  /** SHA of the commit at the tip of this branch. */
  headSha: z.string().max(100),
  /** Whether this branch has protection rules enabled. */
  isProtected: z.boolean().default(false),

  // ── Provider-specific extras ──────────────────────────────────────────
  providerData: z.record(z.string(), z.unknown()).optional(),
})

export type BranchesInput = z.infer<typeof branchesSchema>
